export const reservationsData = [
  {
    key: "1",
    CAR_IMG: "car-01.jpg",
    CAR_NO: "#BR3466",
    CAR: "Ford Endeavour",
    CUSTOMER: "Reuben Keen",
    CUSTOMER_IMG: "customer-01.jpg",
    BADGE: "Client",
    PICK_UP_DATE: "12",
    PICK_UP_DETAILS: "Newyork",
    DROP_OFF_DATE: "13",
    DROP_OFF_DETAILS: "Newyork",
    STATUS: "Completed",
  },
  {
    key: "2",
    CAR_IMG: "car-02.jpg",
    CAR_NO: "#BR3467",
    CAR: " Ferrari 458 MM",
    CUSTOMER: "William Jones",
    CUSTOMER_IMG: "customer-02.jpg",
    BADGE: "Company",
    PICK_UP_DATE: "12",
    PICK_UP_DETAILS: "Newyork",
    DROP_OFF_DATE: "13",
    DROP_OFF_DETAILS: "Newyork",
    STATUS: "Confirmed",
  },
  {
    key: "3",
    CAR_IMG: "car-03.jpg",
    CAR_NO: "#BR3468",
    CAR: " Ford Mustang",
    CUSTOMER: "Leonard Jandreau",
    CUSTOMER_IMG: "customer-03.jpg",
    BADGE: "Company",
    PICK_UP_DATE: "14",
    PICK_UP_DETAILS: "Los Angeles",
    DROP_OFF_DATE: "15",
    DROP_OFF_DETAILS: "Newyork",
    STATUS: "In Rental",
  },
  {
    key: "4",
    CAR_IMG: "car-04.jpg",
    CAR_NO: "#BR3469",
    CAR: " Toyota Tacoma 4",
    CUSTOMER: "Adam Bolden",
    CUSTOMER_IMG: "customer-04.jpg",
    BADGE: "Client",
    PICK_UP_DATE: "14",
    PICK_UP_DETAILS: "Houston",
    DROP_OFF_DATE: "14",
    DROP_OFF_DETAILS: "Newyork",
    STATUS: "Confirmed",
  },
  {
    key: "5",
    CAR_IMG: "car-05.jpg",
    CAR_NO: "#BR3470",
    CAR: " Chevrolet Truck",
    CUSTOMER: "Harvey Jimenez",
    CUSTOMER_IMG: "customer-05.jpg",
    BADGE: "Company",
    PICK_UP_DATE: "14",
    PICK_UP_DETAILS: "Phoenix",
    DROP_OFF_DATE: "15",
    DROP_OFF_DETAILS: "Newyork",
    STATUS: "Rejected",
  },
  {
    key: "6",
    CAR_IMG: "car-06.jpg",
    CAR_NO: "#BR3471",
    CAR: " Etios Carmen",
    CUSTOMER: "William Ward",
    CUSTOMER_IMG: "customer-06.jpg",
    BADGE: "Client",
    PICK_UP_DATE: "14",
    PICK_UP_DETAILS: "Philadelphia",
    DROP_OFF_DATE: "15",
    DROP_OFF_DETAILS: "Newyork",
    STATUS: "Completed",
  },
  {
    key: "7",
    CAR_IMG: "car-07.jpg",
    CAR_NO: "#BR3472",
    CAR: " Acura Sport",
    CUSTOMER: "Norman Coleman",
    CUSTOMER_IMG: "customer-07.jpg",
    BADGE: "Client",
    PICK_UP_DATE: "14",
    PICK_UP_DETAILS: "Philadelphia",
    DROP_OFF_DATE: "15",
    DROP_OFF_DETAILS: "Newyork",
    STATUS: "Confirmed",
  },
  {
    key: "8",
    CAR_IMG: "car-08.jpg",
    CAR_NO: "#BR3473",
    CAR: " Kia Soul 2016",
    CUSTOMER: "Jay Beckman",
    CUSTOMER_IMG: "customer-08.jpg",
    BADGE: "Company",
    PICK_UP_DATE: "04",
    PICK_UP_DETAILS: " Philadelphia",
    DROP_OFF_DATE: "06",
    DROP_OFF_DETAILS: "Newyork",
    STATUS: "Rejected",
  },
  {
    key: "9",
    CAR_IMG: "car-09.jpg",
    CAR_NO: "#BR3474",
    CAR: " Camaro",
    CUSTOMER: "Francis Harris",
    CUSTOMER_IMG: "customer-09.jpg",
    BADGE: "Client",
    PICK_UP_DATE: "04",
    PICK_UP_DETAILS: "Philadelphia",
    DROP_OFF_DATE: "06",
    DROP_OFF_DETAILS: "Newyork",
    STATUS: "Rejected",
  },
  {
    key: "10",
    CAR_IMG: "car-10.jpg",
    CAR_NO: "#BR3475",
    CAR: " Toyota Camry",
    CUSTOMER: "Renaldo Labarre",
    CUSTOMER_IMG: "customer-10.jpg",
    BADGE: "Company",
    PICK_UP_DATE: "04",
    PICK_UP_DETAILS: "Philadelphia",
    DROP_OFF_DATE: "06",
    DROP_OFF_DETAILS: "Newyork",
    STATUS: "In Rental",
  },
];
